













import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import ZoneForm from './zone-form.vue';

class PageZoneRequest extends PageRequest {
}

@Component({
    components: { ListView, ZoneForm, FormBase }
})
export default class Zones extends ListBase {
    entity: string = 'zone';
    pagerequest: PageZoneRequest = new PageZoneRequest();

    columns = [
        this.gCol('name', 'Nombre', 'text'),
        this.gCol('manager.fullname', 'Jefe', 'text'),
        this.gColO({ type: 'editColor', value: 'color', text: 'Color', color: 'color', save: this.saveColor }),
        this.defaultActions()
    ]


    async saveColor(data) {
        await this.$store.dispatch({
            type: 'zone/update',
            data: {
                id: data.id,
                color: data.color
            }
        });
    }

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }
    async afterSave() {
        let list: any = this.$refs.listView
        await list.getpage();
    }     

    mounted() {
        
    }

    created() {
        
    }
}